/**
 * @file_purpose  component created for sm-plexmedia-web page
 * @author Swarnali Ghosh
 * @Date_Created 27-02-2024
 * @Date_Modified 28-02-2024
 */

import React, { useEffect, useState } from 'react'
import ApiURL from '../../apis/ApiURL'
import GeneralService from '../../apis/GeneralService'
import { Link, useLocation } from 'react-router-dom';
import WebBanner from '../webComp/WebBanner'
import WebGameSlider from '../webComp/WebGameSlider'
// import WebProvider from './WebProvider'
// import GameList from '../../pages/game/GameList'
// import WebGameCategory from './WebGameCategory';
// import AuthModal from '../../components/auth/AuthModal'
import { useSelector, useDispatch } from 'react-redux'
import WebGameCategory from './WebGameCategory';
import WebProvider from './WebProvider';
import AuthModal from '../auth/AuthModal';
import Games from '../../pages/game/Games';
import BrowseGames from './BrowseGames';
import BrandHero from './BrandHero';
import { selectProvider } from '../../redux/slices/ProviderSlice';
import { selectCategory } from '../../redux/slices/changeMenuStateSlice';
// import Games from '../../pages/game/Games'
// import { resetListGame } from '../../redux/slices/GameSlice';

const WebContent = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const [state, setState] = useState({
        client_id: "",
        language: ""
    })
    const languageState = useSelector((state) => state.languageState);
    const category_Id = useSelector((state) => state.menuState.categorty);
    const providerId = useSelector((state) => state.providerState.selectProvider);

    let languageCode = languageState.active_language.language_code;
    const [submitDisable, setSubmitDisable] = useState(false);
    const [showAuthModal, setShowAuthModal] = useState(false);

    const [isMainPage, setIsMainPage] = useState(true)

    const [categoryId, setCategoryId] = useState("");

    useEffect(() => {

        // dispatch(resetListGame())

    }, [location?.pathname])

    const openAuthModal = () => {
        setShowAuthModal(!showAuthModal)
    }

    const handleModeChangeAuthModal = () => {
        setShowAuthModal(!showAuthModal)
    }

    const changeCategory = (categoryId) => {
        setCategoryId(categoryId)
    }



    useEffect(() => {
        // console.log(category_Id, providerId);
    }, [])

    const resetData = () => {
        dispatch(selectProvider());
        dispatch(selectCategory());
        window.location.reload()

    }

    return (
        <>
            {/* <div className="container mid_sec">
                <div className="mid_ban">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <WebBanner />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* New clean browse module (aggregator -> category -> provider -> games + iframe launch).
                Old WebProvider/Games kept in the codebase as backup. */}
            <BrowseGames />

            <AuthModal showAuthModal={showAuthModal} handleModeChangeAuthModal={handleModeChangeAuthModal} />

        </>
    )
}

export default WebContent
